<template>
    <fragment>
        <b-table :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage" hover no-border-collapse
            sort-by="" :sort-desc="true" striped stacked="md" show-empty>
            <template #empty>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
                <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                </div>
            </template>
            <template #cell(IsLotePreenchido)="data">
                <font-awesome-icon :icon="data.item.IsLotePreenchido ? 'check' : 'cancel'"
                    :class="data.item.IsLotePreenchido ? 'text-success' : 'text-warning'" />
            </template>
            <template v-slot:cell(detalhes)="row">
                <b-link class="text-dark" @click="row.toggleDetails">
                    <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
                </b-link>
            </template>
            <template #row-details="row">
                <detalhes-itens-vencedores-lote-licitacao :idLote="row.item.IdLoteLicitacao" />
            </template>
        </b-table>
        <table-pagination v-if="totalRows > 10" :total-rows="totalRows" :per-page="10" @pageChange="pageChange" />
    </fragment>
</template>

<script lang="ts">
import TablePagination from '@/components/atos-pessoal/TablePagination.vue'
import ldiService from '@/services/licitacoes/ldiService'
import { detalhes, fieldsVencedoresLicitacaoLote } from '@/types/licitacoes/ldi/fields-lote-licitacao'
import { LicitacaoVencedorLote } from '@/types/licitacoes/ldi/licitacao-vencedor-lote'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'
import DetalhesItensVencedoresLoteLicitacao from './DetalhesItensVencedoresLoteLicitacao.vue'

const CompProps = Vue.extend({
    name: 'DetalhesVencedoresLoteTable',
    components: { DetalhesItensVencedoresLoteLicitacao, TablePagination },
    props: {
        idLicitacao: {
            type: Number,
            required: true
        }
    }
})

@Component
export default class DetalhesVencedoresLoteTable extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = [detalhes, ...fieldsVencedoresLicitacaoLote]
    items: LicitacaoVencedorLote[] = []

    //table-related
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false

    async mounted() {
        await this.loadData()
    }
    async pageChange(value) {
        this.currentPage = value;
        await this.loadData();
    }
    async loadData(): Promise<void> {
        try {
            this.tableBusy = true
            const response = await ldiService.buscarVencedores(this.idLicitacao, this.currentPage, this.pageSize)
            if (response) {
                this.items = response.vencedores.map(l => {
                    const item = l //Object.assign(new LicitacaoVencedorLote(), l)
                    //item.tratarDadosDaAPI()
                    if (item.IdParticipanteLicitacaoNavigation) item.NmParticipante = item.IdParticipanteLicitacaoNavigation.NmParticipante
                    return item
                })
                this.totalRows = response.totalRows
            } else {
                this.$toast.error('Erro ao consultar os vencedores da licitação.');
            }
        } catch (e) {
            console.error(e)
            this.$toast.error('Falha ao buscar vencedores. ' + e)
        } finally {
            this.tableBusy = false
        }
    }
}
</script>

<style scoped></style>